const nonprofits = state => state.nonprofits
const nonprofit = state => state.nonprofit

export default {
  nonprofits,
  nonprofit
};
